import { history } from '@/app/app-reducer';
import { NAV_ITEMS, PROPERTY_DETAILS_TAB_NAMES } from '@/constants';
import * as dashboardActions from '@/dashboard/dashboard-actions';
import { combinePaths } from '@/utils/paths';
import { getCurrentPlaceUrl } from '@/utils/place-detection';
import { smartEncodeURIComponent } from '@/utils/uri-utils';
import isNil from 'lodash/isNil';
import { put, takeLatest } from 'redux-saga/effects';

function* openComplaintByID(
  action: ReturnType<typeof dashboardActions.openComplaintById>
) {
  const complaintID = action.payload;

  const encodedPropertyDeckardId = !isNil(complaintID)
    ? encodeURIComponent(complaintID)
    : '';
  const combinedPaths = combinePaths(
    NAV_ITEMS.complaints,
    encodedPropertyDeckardId
  );
  const targetUrl: string = yield getCurrentPlaceUrl(combinedPaths);
  history.push(targetUrl);
}

export function* openByInternalIDWatcher() {
  yield takeLatest(dashboardActions.openComplaintById.type, openComplaintByID);
}

function* openPropertyByDeckardID(
  action: ReturnType<typeof dashboardActions.openPropertyByDeckardId>
) {
  const [view, propertyDeckardID, tab = PROPERTY_DETAILS_TAB_NAMES.overview] =
    action.payload;

  const encodedPropertyDeckardId = smartEncodeURIComponent(propertyDeckardID);

  const combinedPaths = combinePaths(view, encodedPropertyDeckardId);
  const targetUrl: string = yield getCurrentPlaceUrl(combinedPaths);

  yield put(dashboardActions.updatePropertyDetailsTab({ activeTab: tab }));
  history.push(targetUrl);
}

export function* openPropertyByDeckardIDWatcher() {
  yield takeLatest(
    dashboardActions.openPropertyByDeckardId.type,
    openPropertyByDeckardID
  );
}
